import TextTransformer from "./TextTransformer";

export enum WordInterlinearNumberStyle {
    None,
    AddStandardSequential,
    AddAlternateSequential
}

export interface LexiconLookup {
    readonly verseIndex: number;
    readonly sourceIndex: number;
}

export default interface WordStyle {
    readonly classes?: string[];
    readonly interlinearNumberStyle?: WordInterlinearNumberStyle;
    readonly lexiconLookup?: LexiconLookup;
    readonly tooltipGenerator?: TextTransformer;
    readonly partTransformer?: TextTransformer;
    readonly partSeparator?: string;
    readonly partJoiner?: string;
    readonly emptyText?: string;
}
